import { render, staticRenderFns } from "./FlyersListPage.vue?vue&type=template&id=37ec7420&"
import script from "./FlyersListPage.vue?vue&type=script&lang=js&"
export * from "./FlyersListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports